import React from "react";
import { useLocation, useSearchParams, Redirect } from "wouter";
import { Show } from "@clerk/react";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Wifi } from "lucide-react";

const HIGHLIGHTS = [
  "Earn commission on every fibre connection",
  "Track your orders and payouts in real time",
  "Get support from your account manager",
];

export function InviteAccept() {
  const [, setLocation] = useLocation();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  return (
    <>
      {/* Already signed in → straight to the app (gate handles onboarding). */}
      <Show when="signed-in">
        <Redirect to="/home" />
      </Show>
      <Show when="signed-out">
        <div className="font-sans min-h-[100dvh] w-full max-w-[480px] mx-auto bg-[#0B132B] text-white flex flex-col">
          <header className="px-6 pt-8 pb-4">
            {/* Co-brand lockup: OpenServe is the primary (bigger) brand, Mooya the
                secondary partner. Sits on a white chip so the colour logos stay
                legible on the navy page (MooyaLogo.png has a solid white bg). */}
            <div className="inline-flex items-center gap-3 bg-white rounded-xl px-4 py-2.5 shadow-sm">
              <img
                src={`${import.meta.env.BASE_URL}landing/OpenServeLogo.png`}
                alt="OpenServe"
                className="h-10 w-auto object-contain"
              />
              <div className="w-px h-8 bg-gray-200" />
              <img
                src={`${import.meta.env.BASE_URL}landing/MooyaLogo.png`}
                alt="Mooya Wireless"
                className="h-6 w-auto object-contain"
              />
            </div>
          </header>

          <main className="flex-1 flex flex-col px-6 pt-6">
            <div className="w-12 h-12 rounded-full bg-[#E6007E]/15 flex items-center justify-center mb-6">
              <Wifi className="w-6 h-6 text-[#E6007E]" />
            </div>
            <h1 className="text-3xl font-bold tracking-tight mb-3">
              You've been invited to become an OpenServe fibre agent
            </h1>
            <p className="text-slate-300 mb-8">
              Create your account to start onboarding. It only takes a few
              minutes.
            </p>

            <ul className="space-y-3 mb-10">
              {HIGHLIGHTS.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#00A859] mt-0.5 shrink-0" />
                  <span className="text-sm text-slate-200">{h}</span>
                </li>
              ))}
            </ul>
          </main>

          <footer className="px-6 pb-10 space-y-3">
            <Button
              onClick={() =>
                setLocation(
                  token ? `/sign-up?invite=${encodeURIComponent(token)}` : "/sign-up",
                )
              }
              className="w-full bg-[#E6007E] hover:bg-[#c4006b] text-white rounded-xl py-6 text-base font-semibold"
            >
              Accept invitation
            </Button>
            <button
              onClick={() => setLocation("/sign-in")}
              className="w-full text-sm text-slate-300 hover:text-white transition-colors py-2"
            >
              Already have an account? Sign in
            </button>
          </footer>
        </div>
      </Show>
    </>
  );
}
